import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

export const selectProducts = (store: StoreSchema) => store.products.products

export const selectOneProduct = (guid: string) =>
    createSelector([selectProducts], (products) =>
        products.find((product) => product.guid === guid),
    )
